import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import moment from "moment";
import { setSelectedInspectionStation } from "../../features/admin3/admin3Slice";
import { CiSquarePlus } from "react-icons/ci";

const Container = styled.div`
  width: 100%;
    .main {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      margin: 0;
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(8, 1fr);
        text-align: center;
        gap: 15px;
        position: relative;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
        }
      }
      .plus{
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        color: var(--color-main);
        font-size: 22px;
        display: flex;
        justify-content: center;
        align-items: center
      }
    }
`;

const AdminKarayollariContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();


  return (
    <Container onClick={() => {dispatch(setSelectedInspectionStation(data)); dispatch(showModal("updateKarayollariIstasyon"))}}>
        <div className="main">
          <div className="row">
            <div className="col">{moment(data.createdAt).format("DD.MM.YYYY HH:mm")}</div>
            <div className="col">{data.stationName}</div>
            <div className="col">{data.city}</div>
            <div className="col">{data.district}</div>
            <div className="col">{data.location}</div>
            <div className="col">{data.direction ? "Çift Yön" : "Tek Yön"}</div>
            <div className="col">{data.latitude}</div>
            <div className="col">{data.longitude}</div>
          </div>
          <div onClick={(e) => {e.stopPropagation(); dispatch(setSelectedInspectionStation(data)); dispatch(showModal("createRoadRoute"))}} className="plus">
            <CiSquarePlus />
          </div>
        </div>
    </Container>
  );
};

export default AdminKarayollariContainer;
